import { EDUCATION_HOST, PROBLEM_STATUS_DISPLAY_NAMES } from '@yandex-int/k-common/constants';
import find from 'lodash/find';

export function getTableFromClessonResults({
    intl,
    clessonId,
    course,
    studentsProblems,
    clessonProblems,
    clessonUserIds,
}) {
    const headers = [];
    const result = [];

    // формируем колонки заголовка
    headers.push(
        intl.formatMessage({ id: 'table.userId' }),
        intl.formatMessage({ id: 'table.lastname' }),
        intl.formatMessage({ id: 'table.firstname' }),
        intl.formatMessage({ id: 'table.login' })
    );

    clessonProblems.forEach((problem) => {
        headers.push(problem.number, `${problem.number} - ${intl.formatMessage({ id: 'table.attemptCount' })}`);
    });

    headers.push(intl.formatMessage({ id: 'table.studentLink' }));

    // добавляем заголовки в результат
    result.push(headers);

    // заполняем таблицу
    result.push(
        ...clessonUserIds.map((id) => {
            const student = find(course.students, { id });
            const studentStats = studentsProblems[id];

            const row = [id, student.last_name, student.first_name, student.username];

            clessonProblems.forEach((problem) => {
                const currentProblem = studentStats.problems[problem.problemLinkId];
                let status;

                if (currentProblem.status === PROBLEM_STATUS_DISPLAY_NAMES.CORRECT) {
                    status = 1; // 1: решил верно
                } else if (
                    currentProblem.status !== PROBLEM_STATUS_DISPLAY_NAMES.CORRECT &&
                    currentProblem.attempt_number < currentProblem.max_attempts
                ) {
                    status = 2; // 2: решил неверно, но есть еще попытки
                } else if (
                    currentProblem.status !== PROBLEM_STATUS_DISPLAY_NAMES.CORRECT &&
                    currentProblem.attempt_number >= currentProblem.max_attempts
                ) {
                    status = 3; // 3: решил неверно, нет попыток
                } else if (currentProblem.status === PROBLEM_STATUS_DISPLAY_NAMES.NO_ANSWER) {
                    status = 4; // 4: не нажимал на кнопку "ответить" (не решал)
                } else {
                    status = -1;
                }

                row.push(status);
                row.push(currentProblem.attempt_number || 0);
            });

            row.push(EDUCATION_HOST + `/school/lab/students/${id}/courses/${course.id}/assignments/${clessonId}/`);

            return row;
        })
    );

    return result;
}

export function getTableFromCourseJournal({ intl, journal, lessons, courseId }) {
    const headers = [];
    const result = [];

    // формируем колонки заголовка
    headers.push(
        intl.formatMessage({ id: 'table.userId' }),
        intl.formatMessage({ id: 'table.lastname' }),
        intl.formatMessage({ id: 'table.firstname' }),
        intl.formatMessage({ id: 'table.login' })
    );

    // формируем заголовок - "номер занятия : название занятия"
    lessons.forEach((lesson, i) => {
        headers.push(`${i + 1} : ${lesson.name}`);
    });
    headers.push(intl.formatMessage({ id: 'table.journalLink' }));

    result.push(headers);

    journal.toJS().forEach((record) => {
        const {
            student: { id, last_name: lastName, first_name: firstName, username },
            lessons: studentLessons,
        } = record;
        const studentResult = [];

        studentResult.push(id, lastName, firstName, username);
        studentResult.push(...studentLessons);
        studentResult.push(`${EDUCATION_HOST}/school/lab/students/${id}/courses/${courseId}/`);

        result.push(studentResult);
    });

    return result;
}
